<template>
  <svg width="12" height="12" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
    <g>
      <path d="M10.8557 2L12 2L12 3.43273L5.99432 10L4.76607 8.65726L10.8557 2Z" fill="currentColor" />
      <path
        d="M3.55079 7.32345L-6.30174e-08 3.44167L0 2.00188L1.1298 2.00188L4.77259 5.986L3.55079 7.32345Z"
        fill="currentColor"
      />
    </g>
  </svg>
</template>
